export enum GameOptionsTab {
  SYSTEM,
  INTERFACE,
  GAMEPLAY,
  MISC,
}
